import { render, staticRenderFns } from "./VerifyWorkEmail.vue?vue&type=template&id=2b50ba4a&scoped=true"
import script from "./VerifyWorkEmail.vue?vue&type=script&lang=js"
export * from "./VerifyWorkEmail.vue?vue&type=script&lang=js"
import style0 from "./VerifyWorkEmail.vue?vue&type=style&index=0&id=2b50ba4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b50ba4a",
  null
  
)

export default component.exports